// extracted by mini-css-extract-plugin
export default {"container":"container__1Bhsp","dot":"dot__3uplw"};